<template>
  <ContactInquiryItem v-for="(item, itemIndex) in inquiries" :key="itemIndex" :item="item" @search="search" />
</template>

<script setup lang="ts">
import ContactInquiryItem from '@/components/domains/self-service/contact/ContactInquiryItem.vue';
import { IResponseSelfServiceInquiry } from '@/types/response';

withDefaults(
  defineProps<{
    inquiries: IResponseSelfServiceInquiry[];
  }>(),
  {
    inquiries: () => [],
  }
);

const emit = defineEmits<{ search: [] }>();

const search = () => {
  emit('search');
};
</script>

<style scoped></style>
